import { Directive, HostListener, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ selector: "[pin-mask]" })
export class PINMaskDirective implements OnInit {
    constructor(public ngControl: NgControl) {}

    ngOnInit(): void {
        if (!this.ngControl.value) return;
        let newVal: string = this.ngControl.value.toString();
        //replace any symbols with empty string, leaving us with only letter and digits
        //S5S4R1H45
        newVal = newVal.replace(/[^\w]/g, "");

        if (newVal.length === 0) {
            newVal = "";
        } else if (newVal.length <= 3) {
            newVal = newVal.replace(/^(\w{0,3})/, "$1");
        } else if (newVal.length <= 6) {
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})/, "$1-$2");
        } else if (newVal.length <= 9) {
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})(\w{0,3})/, "$1-$2-$3");
        } else {
            //longer than it should be
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})(\w{0,3})/, "$1-$2-$3");
        }
        this.ngControl.valueAccessor.writeValue(newVal);
    }

    @HostListener("ngModelChange", ["$event"])
    onModelChange(event) {
        this.onInputChange(event, false);
    }

    @HostListener("keydown.backspace", ["$event"])
    keydownBackspace(event) {
        this.onInputChange(event.target.value, true);
    }

    onInputChange(event, backspace) {
        if (event == null) {
            return "";
        }
        let newVal = event.replace(/[^\w]/g, "");

        if (newVal.length === 0) {
            newVal = "";
        } else if (newVal.length <= 3) {
            newVal = newVal.replace(/^(\w{0,3})/, "$1");
        } else if (newVal.length <= 6) {
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})/, "$1-$2");
        } else if (newVal.length <= 9) {
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})(\w{0,3})/, "$1-$2-$3");
        } else {
            //longer than it should be
            newVal = newVal.replace(/^(\w{0,3})(\w{0,3})(\w{0,3})/, "$1-$2-$3");
        }
        this.ngControl.valueAccessor.writeValue(newVal);
    }
}
